import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '@paypalcorp/pp-react'
import styles from './gift-options.styles'
import { css } from 'lib/paypalphrodite'
import classNames from 'classnames'
import glamorousIcon from 'lib/glamorous-icon'
import { GIFT_OPTIONS } from '../../constants'
import iconPpdg from './resources/icon-ppdg.svg'
import content from 'pp-react-l10n'

let i18n = content('transfer/themes')
const PpdgIcon = glamorousIcon({
  boxSizing: 'border-box',
  height: 45,
  width: 60,
  border: '1px solid #0070BA',
  backgroundColor: '#FFFFFF',
  borderRadius: 60,
  padding: 7,
  color: '#0070BA',
  fontSize: 36,
  lineHeight: 0,
  '& svg': { height: 28, width: 30 },
})

class GiftEntry extends React.Component {
  static propTypes = {
    giftOption: PropTypes.string.isRequired,
    handleChangeGiftOption: PropTypes.func.isRequired,
    selectedGiftOption: PropTypes.string.isRequired,
  }

  handleGiftOptionClick = event => {
    const selectedTag = event.currentTarget.dataset.value
    const { selectedGiftOption } = this.props
    const newGiftOption = selectedGiftOption === selectedTag ? '' : selectedTag
    this.props.handleChangeGiftOption(newGiftOption)
  }

  handleGiftOptionOnKeyPress = event => {
    if (event.keyCode === 32) {
      this.handleGiftOptionClick(event)
    }
  }

  getGiftOptionIcon = () => {
    const { giftOption } = this.props
    if (giftOption === GIFT_OPTIONS.ecard) {
      return (
        <span
          name="gift"
          className={classNames('icon', 'icon-gift', css(styles.ovalIcon))}
        />
      )
    }
    return <PpdgIcon svg={iconPpdg} />
  }

  render() {
    const { selectedGiftOption, giftOption } = this.props
    const giftOptionClass = classNames({
      [css(styles.optionsWrapper)]: true,
      [css(styles.selectedOption)]: selectedGiftOption === giftOption,
    })
    return (
      <div
        role="button"
        tabIndex="0"
        onKeyUp={this.handleGiftOptionOnKeyPress}
        data-value={giftOption}
        onClick={this.handleGiftOptionClick}
        className={giftOptionClass}
      >
        {selectedGiftOption === giftOption ? (
          <Icon
            name="check-alt"
            className={css(styles.ovalIcon, styles.checkIcon)}
          />
        ) : (
          this.getGiftOptionIcon()
        )}
        <div>
          <span className={css(styles.optionHeader)}>
            {giftOption === GIFT_OPTIONS.ecard
              ? i18n('giftOptions.ecard.header')
              : i18n('giftOptions.ppdg.header')}
          </span>
          <span className={css(styles.optionDetail)}>
            {giftOption === GIFT_OPTIONS.ecard
              ? i18n('giftOptions.ecard.description')
              : i18n('giftOptions.ppdg.description')}
          </span>
        </div>
      </div>
    )
  }
}

export default GiftEntry
